<template>
  <div id="reset-password-form" class="box auth" @keyup.enter="resetPassword()">
    <h1 class="title is-size-3 has-text-centered">
      {{ $t('reset_password_form.title') }}
    </h1>

    <div
      class="message is-small is-danger animated fast fadeIn"
      v-if="errorMessage"
    >
      <div class="message-body">{{ $t(errorMessage) }}</div>
    </div>

    <div
      class="message is-small is-success animated fast fadeIn"
      v-if="hasResetPassword"
    >
      <div class="message-body">
        <p>{{ $t('reset_password_form.success.reset_password') }}</p>
      </div>
    </div>

    <div class="field">
      <label for="email" class="label">
        {{ $t('reset_password_form.email_label') }}
      </label>

      <div class="control">
        <input
          type="email"
          id="email"
          class="input is-shadowless"
          required
          autofocus
          v-model="email"
        />
      </div>
    </div>

    <div class="field">
      <label for="code" class="label">{{
        $t('reset_password_form.verification_code_label')
      }}</label>
      <div class="control">
        <input
          type="text"
          id="code"
          name="code"
          autocomplete="off"
          class="input is-shadowless"
          required
          v-model="resetToken"
        />
      </div>
    </div>

    <div class="field">
      <label for="password" class="label">
        <span>{{ $t('reset_password_form.new_password_label') }}</span>
        <div class="tooltip-container">
          <i class="material-icons">&#xE88F;</i>
          <div class="tooltip tooltip-top" role="tooltip">
            <div class="tooltip-outer">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-inner">
                {{ $t('login_form.business_password_strength') }}
              </div>
            </div>
          </div>
        </div>
      </label>
      <div class="control">
        <input
          type="password"
          id="password"
          class="input is-shadowless"
          required
          v-model="password"
        />
      </div>
    </div>

    <div class="field field-action">
      <div class="control">
        <gradient-button
          :title="$t('reset_password_form.reset_password_button')"
          :is-inline="true"
          :is-loading="isLoading"
          @click.native="resetPassword()"
        ></gradient-button>
        <div class="help">
          {{ $t('reset_password_form.sign_in_link.prefix') }}
          <router-link to="/login" class="has-text-info">{{
            $t('reset_password_form.sign_in_link.label')
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from 'services/Cognito';
import { GradientButton } from 'components/buttons';
import { isPasswordValid } from 'utils/auth';

export default {
  components: {
    GradientButton,
  },

  data() {
    return {
      email: '',
      password: '',
      resetToken: '',
      errorMessage: '',
      isLoading: false,
      hasResetPassword: false,
    };
  },

  methods: {
    async resetPassword() {
      if (this.isLoading) {
        return;
      }

      if (this.email === '') {
        this.errorMessage = 'reset_password_form.errors.email_empty_field';
        return;
      }

      if (this.password === '') {
        this.errorMessage = 'reset_password_form.errors.password_empty_field';
        return;
      }

      if (!this.resetToken) {
        this.errorMessage =
          'reset_password_form.errors.reset_token_empty_field';
        return;
      }

      if (!isPasswordValid(this.password)) {
        this.errorMessage = this.$t('login_form.business_password_strength');
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';

      try {
        await Auth.forgotPasswordSubmit(
          this.email,
          this.resetToken,
          this.password
        );
        this.errorMessage = '';
        this.hasResetPassword = true;

        // Not setting isLoading to false again as we want to redirect
        // and not permit any action before redirection
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000);
      } catch (err) {
        this.errorMessage =
          err.message || 'reset_password_form.errors.reset_password_failed';
        this.hasResetPassword = false;
        this.isLoading = false;
      }
    },
  },
};
</script>
